// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"21717bdc","707":"3424a9dc","729":"2d0c3031"}[chunkId] + ".js";
};